import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ShoppingBag, ChevronRight } from 'lucide-react';
import { useCart } from '../../lib/cart';
import { useLanguage } from '../../lib/i18n';
import { formatCurrency, cn } from '../../lib/utils';
interface FloatingCartButtonProps {
  primaryColor?: string;
  className?: string;
}
export function FloatingCartButton({
  primaryColor = '#F59E0B',
  className
}: FloatingCartButtonProps) {
  const {
    getItemCount,
    getTotal,
    cart
  } = useCart();
  const {
    t
  } = useLanguage();
  const {
    slug: urlSlug
  } = useParams<{
    slug: string;
  }>();
  const count = getItemCount();
  const total = getTotal();
  // Fallback to URL slug if cart doesn't have it (for legacy carts)
  const targetSlug = cart.restaurantSlug || urlSlug;
  if (count === 0) return null;
  return <div className={cn('fixed bottom-6 left-0 right-0 z-40 px-4 sm:px-6 lg:px-8 pointer-events-none', className)} data-id="element-2763" data-mp="2i8ogs3w5p55w">
      <div className="max-w-5xl mx-auto flex justify-center sm:justify-end" data-id="element-2764" data-mp="2d78xohdjh8q5">
        <Link to={targetSlug ? `/r/${targetSlug}/cart` : '/cart'} className="pointer-events-auto flex items-center justify-between w-full sm:w-auto min-w-[320px] bg-brand-charcoal text-white rounded-2xl p-4 shadow-xl hover:shadow-2xl transition-all hover:-translate-y-1 group" data-id="element-2765" data-mp="199c4j3t3colk">
          <div className="flex items-center gap-3" data-id="element-2766" data-mp="14c2fhp9m6ey9">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{
            backgroundColor: primaryColor
          }} data-id="element-2767" data-mp="1s14uepcv5tp2">
              <ShoppingBag className="w-5 h-5 text-white" data-id="element-2768" data-mp="1icd7ivmntzl0" />
            </div>
            <div className="flex flex-col" data-id="element-2769" data-mp="1naoe8xhnrtz0">
              <span className="font-semibold text-sm text-gray-300" data-id="element-2770" data-mp="1n9dd75fll0bl">
                {t('view_order')}
              </span>
              <span className="font-bold text-lg leading-none" data-id="element-2771" data-mp="2ay61qgtw45w6">
                {count} {count === 1 ? t('product') : t('products')}
              </span>
            </div>
          </div>

          <div className="flex items-center gap-3" data-id="element-2772" data-mp="2pmfxccq3ua2j">
            <span className="font-bold text-xl" data-id="element-2773" data-mp="2knd0vgo6xc66">{formatCurrency(total)}</span>
            <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-white transition-colors group-hover:translate-x-1" data-id="element-2774" data-mp="2gm9k8rybjc3w" />
          </div>
        </Link>
      </div>
    </div>;
}